import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'site-modules/shared/components/link/link';

export function ThankYouText({ isUpdateForm = false }) {
  return (
    <Fragment>
      <div className="heading-4 mb-0_5">Thank you for {isUpdateForm ? 'updating' : 'submitting'} your review</div>
      <div className="mb-1_5">
        Please check your email to confirm your email address. Once you confirm your email, it may take up to two
        business days for your review to appear as we review all submissions prior to publishing them.
      </div>
      <Link
        className="text-primary-darker d-block"
        to="/car-reviews/consumer-ratings-reviews.html"
        data-tracking-id="wr_review_another_vehicle"
      >
        Review another vehicle
        <i className="icon-arrow-right4 d-inline-block size-10 ps-0_25" aria-hidden />
      </Link>
    </Fragment>
  );
}

ThankYouText.propTypes = {
  isUpdateForm: PropTypes.bool,
};
